// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__TgBKX","active":"Menu_active__pkuSp","inactive":"Menu_inactive__hFEPA"};